import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from "../redux/actions/authSlice";
import commonReducer from "../redux/reducer/commonReducer";
import dashboardReducer from "../redux/actions/dashboardSlice";
import workshopReducer from "../redux/actions/workshopSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    common: commonReducer,
    dashboard: dashboardReducer,
    workshop:workshopReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

